import { useState } from "react";

const SITE = typeof window !== "undefined" ? window.location.origin : "";
const TITLE = "Twice Built, Twice Broken — a memoir of love, loss & reinvention";

function buildShareLinks(url, text) {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(text);
  return {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
    twitter:  `https://twitter.com/intent/tweet?url=${u}&text=${t}`,
    whatsapp: `https://api.whatsapp.com/send?text=${t}%20${u}`,
    email:    `mailto:?subject=${t}&body=${u}`,
  };
}

export function ShareRow({ url = SITE, text = TITLE, compact = false, testid = "share" }) {
  const [copied, setCopied] = useState(false);
  const links = buildShareLinks(url, text);

  const copy = async (e) => {
    e?.preventDefault?.();
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    } catch {
      // clipboard may be unavailable in older browsers — silently ignore
    }
  };

  return (
    <div
      className={"share-row" + (compact ? " share-row-compact" : "")}
      data-testid={testid}
    >
      {!compact && <span className="share-label">Share:</span>}
      <a
        className="share-btn share-fb"
        href={links.facebook}
        target="_blank"
        rel="noopener noreferrer"
        title="Share on Facebook"
        data-testid={`${testid}-fb`}
        aria-label="Share on Facebook"
      >f</a>
      <a
        className="share-btn share-x"
        href={links.twitter}
        target="_blank"
        rel="noopener noreferrer"
        title="Share on X / Twitter"
        data-testid={`${testid}-x`}
        aria-label="Share on X"
      >X</a>
      <a
        className="share-btn share-wa"
        href={links.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        title="Share on WhatsApp"
        data-testid={`${testid}-wa`}
        aria-label="Share on WhatsApp"
      >W</a>
      <a
        className="share-btn share-mail"
        href={links.email}
        title="Share by email"
        data-testid={`${testid}-mail`}
        aria-label="Share by email"
      >@</a>
      <button
        type="button"
        onClick={copy}
        className={"share-btn share-copy" + (copied ? " share-copied" : "")}
        title="Copy link"
        data-testid={`${testid}-copy`}
        aria-label="Copy link"
      >{copied ? "✓" : "↗"}</button>
    </div>
  );
}
